(function($) {

  /**
   * Resize select elements to match the selected option length
   */
  const arrowWidth = 30;

  $.fn.resizeselect = function(settings) {
    return this.each(function() {

      $(this).change(function() {
        let $this = $(this);

        // create test element
        let text = $this.find("option:selected").text();
        let $test = $("<span>").html(text).css({
          "font-size": $this.css("font-size"), // ensures same size text
          "visibility": "hidden" // prevents FOUC
        });

        // add to parent, get width, and get out
        $test.appendTo($this.parent());
        let width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);

        // run on start
      }).change();

    });
  };
  // run by default
  $(".konsertti-filter--select").resizeselect();


  /**
   * Filter stuff
   */

  let options = {
    valueNames: [
      //'soittokunta',
      'soittokunta_val',
      'maakunta',
      'calendar-card__title',
      'location-info', // for search
      'short-info', // for search
      // {
      //   attr: 'data-maakunta',
      //   name: 'maakunta'
      // },
      // {
      //   attr: 'data-month-year',
      //   name: 'paivamaara'
      // }
    ]
  };

  let current_filters_arr = {
    selects: '',
    //date: new Date()
  };


  let konserttiList = new List('calendar-card-container', options);


  // const $current_date_field = $('.konsertti-filter__current_day_month');
  // current_filters_arr.date = $current_date_field.html();
  //
  // const date_format_options = {
  //   month: "long"
  // };

  const current_locale = $('html').prop('lang');


  // Run filter with date and select values combined
  let run_konsertti_filter = function() {
    if ('function' === typeof konserttiList.filter) {
      konserttiList.filter(function(item) {


        let soittokunta_filter_val = "";
        let maakunta_filter_val = "";

        if (current_filters_arr.selects.length) {

          current_filters_arr.selects.forEach(function(e) {
            if (e.prop === 'soittokunta') {
              soittokunta_filter_val = e.value;
            }
            if (e.prop === 'maakunta') {
              maakunta_filter_val = e.value;
            }
          });
        }


        //return (!current_filters_arr.selects.length || current_filters_arr.selects.every(f => f.value === item.values()[f.prop])) && (item.values().paivamaara === current_filters_arr.date);

        // We're using fuzzy match for advanced filtering:
        // https://github.com/forrestthewoods/lib_fts/blob/master/docs/fuzzy_match.md


        return (!current_filters_arr.selects.length ||
          ("" === soittokunta_filter_val || fuzzyMatchSimple(soittokunta_filter_val, item.values().soittokunta_val)) &&
          ("" === maakunta_filter_val || item.values().maakunta === maakunta_filter_val));
      });
    }
  };



  /**
   * Filter month / year
   */
  /*
  let now = new Date();

  $('.konsertti-filter--month-prev').on('click', function() {
    const past = now.setMonth(now.getMonth() - 1);
    $current_date_field.html(now.toLocaleString(current_locale, date_format_options) + ' ' + now.getFullYear());
    current_filters_arr.date = $current_date_field.html();
    run_konsertti_filter();
  });

  $('.konsertti-filter--month-next').on('click', function() {
    const future = now.setMonth(now.getMonth() + 1);
    $current_date_field.html(now.toLocaleString(current_locale, date_format_options) + ' ' + now.getFullYear());
    current_filters_arr.date = $current_date_field.html();
    run_konsertti_filter();
  });

  $('.konsertti-filter--month-this').on('click', function() {
    now = new Date();
    $current_date_field.html(now.toLocaleString(current_locale, date_format_options) + ' ' + now.getFullYear());
    current_filters_arr.date = $current_date_field.html();
    run_konsertti_filter();
  });
  */


  /**
   * Filter selects
   */
  const $selects = $('select.konsertti-filter--select').change((e) => {

    const filterArr = $selects.toArray()
      .filter(el => !!el.value)
      .map(el => ({
        prop: el.dataset.prop,
        value: el.value
      }));

    current_filters_arr.selects = filterArr;
    run_konsertti_filter();
  });


  /**
   * Show all
   */
  $('.konsertti-filter--show-all').on('click', function() {
    // clear date
    //now = new Date();
    //$current_date_field.html(now.toLocaleString(current_locale, date_format_options) + ' ' + now.getFullYear());

    // clear selects
    $('select.konsertti-filter--select').val("");

    // populate filter values with defaults
    current_filters_arr.selects = "";
    //current_filters_arr.date = $current_date_field.html();

    run_konsertti_filter();
    //konserttiList.filter();
    return false;
  });



  /**
   * Msg on no results
   */
  const $no_results = $('.konsertti-filter__noresults');
  konserttiList.on('updated', function(list) {
    if (list.matchingItems.length > 0) {
      // results
      $no_results.hide();
    } else {
      // no results
      $no_results.show();
    }
  });


  // Run initially to show only the ones happening this month
  run_konsertti_filter();



})(jQuery);